import classNames from 'classnames';
import { useFormikContext } from 'formik';
import { useState } from 'react';
import { CollectionPointSearchParams, CollectionPointWithI18nKey } from '../../../types/collectionPoints';
import { config } from '../../../utils/config';
import { useScriptWithLoadedState } from '../../../utils/useScript';
import DetailPage from './DetailPage';
import SearchPage from './SearchPage';
import { getInitialSearchParams } from './SearchPage/searchUtils';
import { ViewOption } from './SearchPage/ViewOptions';
import './style.scss';

const CollectionPoints = ({ isStorePickup }: { isStorePickup: boolean }) => {
  const [results, setResults] = useState<CollectionPointWithI18nKey[]>();
  const [searchParams, setSearchParams] = useState<CollectionPointSearchParams>(getInitialSearchParams());
  const [view, setView] = useState<ViewOption>('map');
  const isMapView = view === 'map';
  const { setFieldValue, values } = useFormikContext<any>();

  const googleMapsOptions = {
    key: GOOGLE_MAPS_API_KEY,
    libraries: 'places',
    region: config.country,
    language: config.locale.replace('_', '-'),
  };
  const isGoogleMapsSdkLoaded = useScriptWithLoadedState(
    `https://maps.googleapis.com/maps/api/js?${new URLSearchParams(googleMapsOptions)}`
  );

  const onSelect = (id: string) => {
    const { carrierKey, carrierGroupKey, shippingOptionKey, collectionPointType, deliveryOptionKey } = results!.find(
      location => location.specification.collectionPointId === id
    )!.deliveryOption;
    setFieldValue('collectionPoint.id', id);
    setFieldValue('collectionPoint.type', {
      carrierKey,
      carrierGroupKey,
      shippingOptionKey,
      collectionPointType,
      deliveryOptionKey,
    });
  };

  const selectedLocation = results?.find(
    location => values.collectionPoint.id === location.specification.collectionPointId
  );

  const onBackButtonClick = () => {
    setFieldValue('collectionPoint.id', '');
    setFieldValue('collectionPoint.type', {
      carrierGroupKey: '',
      carrierKey: '',
      shippingOptionKey: '',
      collectionPointType: '',
      deliveryOptionKey: '',
    });
  };

  return (
    <div
      className={classNames('collection-points', {
        'collection-points--list-view': !isMapView,
        'collection-points--with-location-details': !!selectedLocation,
      })}
    >
      {!selectedLocation ? (
        <SearchPage
          searchParams={searchParams}
          setSearchParams={setSearchParams}
          results={results}
          setResults={setResults}
          onSelect={onSelect}
          view={view}
          setView={setView}
          isStorePickup={isStorePickup}
          isGoogleMapsSdkLoaded={isGoogleMapsSdkLoaded}
        />
      ) : (
        <DetailPage
          location={selectedLocation}
          view={view}
          onBackButtonClick={onBackButtonClick}
          isGoogleMapsSdkLoaded={isGoogleMapsSdkLoaded}
        />
      )}
    </div>
  );
};

export default CollectionPoints;
